import React from "react";
import SortableLink from "../../SortableLink";

function Header({ sortedField, doSort }) {
    return (
        <thead>
            <tr>
                <th>
                    <SortableLink
                        title="Εταιρία"
                        sortField="company"
                        sortedField={sortedField}
                        doSort={doSort}
                    />
                </th>
                <th>
                    <SortableLink
                        title="Περιοχή"
                        sortField="area"
                        sortedField={sortedField}
                        doSort={doSort}
                    />
                </th>
                <th>
                    <SortableLink
                        title="Πόλη"
                        sortField="city"
                        sortedField={sortedField}
                        doSort={doSort}
                    />
                </th>
                <th>
                    <SortableLink
                        title="Νομός"
                        sortField="nomos"
                        sortedField={sortedField}
                        doSort={doSort}
                    />
                </th>
                <th>
                    <SortableLink
                        title="Τ.Κ."
                        sortField="zipCode"
                        sortedField={sortedField}
                        doSort={doSort}
                    />
                </th>
                <th>ΑΦΜ</th>
                <th>Σειριακός</th>
                <th>Τομέας</th>
                <th>Μέθοδος</th>
                <th>
                    <SortableLink
                        title="Συναλλαγές"
                        sortField="transactions"
                        sortedField={sortedField}
                        doSort={doSort}
                    />
                </th>
                <th>
                    <SortableLink
                        title="Προμήθεια"
                        sortField="commissions"
                        sortedField={sortedField}
                        doSort={doSort}
                    />
                </th>
            </tr>
        </thead>
    );
}

export default Header;
